// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ly-1";
export var messageSideRight = "_ly-2";
export var subscribeToBackInStockBubbleContainer = "_ly-0";